// @ts-nocheck
(function () {
  'use strict';

  /* ── Icons ──────────────────────────────────────────────────── */
  var ICON = {
    close:   '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0008 10.5896L5.62896 14.9613C5.55104 15.0394 5.45542 15.081 5.34208 15.0863C5.22889 15.0917 5.12799 15.0501 5.03937 14.9613C4.95062 14.8727 4.90625 14.7744 4.90625 14.6665C4.90625 14.5586 4.95062 14.4603 5.03937 14.3717L9.41104 9.99986L5.03937 5.62798C4.96132 5.55007 4.91965 5.45444 4.91437 5.34111C4.90896 5.22791 4.95062 5.12701 5.03937 5.0384C5.12799 4.94965 5.22625 4.90527 5.33417 4.90527C5.44208 4.90527 5.54035 4.94965 5.62896 5.0384L10.0008 9.41006L14.3727 5.0384C14.4506 4.96034 14.5462 4.91868 14.6596 4.9134C14.7728 4.90798 14.8737 4.94965 14.9623 5.0384C15.051 5.12701 15.0954 5.22527 15.0954 5.33319C15.0954 5.44111 15.051 5.53937 14.9623 5.62798L10.5906 9.99986L14.9623 14.3717C15.0403 14.4496 15.082 14.5453 15.0873 14.6586C15.0927 14.7718 15.051 14.8727 14.9623 14.9613C14.8737 15.0501 14.7754 15.0944 14.6675 15.0944C14.5596 15.0944 14.4613 15.0501 14.3727 14.9613L10.0008 10.5896Z" fill="#010202"/></svg>',
    check:   '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.81794 11.7887L6.88211 9.85266C6.76669 9.73738 6.62162 9.67836 6.4469 9.67558C6.27232 9.67294 6.12461 9.73197 6.00378 9.85266C5.88308 9.9735 5.82273 10.1199 5.82273 10.2918C5.82273 10.4638 5.88308 10.6102 6.00378 10.731L8.29065 13.0179C8.44135 13.1684 8.61711 13.2437 8.81794 13.2437C9.01878 13.2437 9.19454 13.1684 9.34523 13.0179L13.9815 8.38162C14.0968 8.2662 14.1558 8.12113 14.1586 7.94641C14.1612 7.77183 14.1022 7.62412 13.9815 7.50329C13.8607 7.38259 13.7143 7.32225 13.5423 7.32225C13.3704 7.32225 13.224 7.38259 13.1032 7.50329L8.81794 11.7887ZM10.0021 17.9168C8.90711 17.9168 7.87787 17.7091 6.9144 17.2935C5.95093 16.8779 5.11287 16.314 4.40023 15.6016C3.6876 14.8893 3.12336 14.0516 2.70753 13.0885C2.29183 12.1254 2.08398 11.0965 2.08398 10.0016C2.08398 8.90662 2.29176 7.87738 2.70732 6.91391C3.12287 5.95044 3.68683 5.11238 4.39919 4.39975C5.11155 3.68711 5.94926 3.12287 6.91232 2.70704C7.87537 2.29134 8.90433 2.0835 9.99919 2.0835C11.0942 2.0835 12.1234 2.29127 13.0869 2.70683C14.0504 3.12238 14.8884 3.68634 15.6011 4.3987C16.3137 5.11107 16.8779 5.94877 17.2938 6.91183C17.7095 7.87488 17.9173 8.90384 17.9173 9.9987C17.9173 11.0937 17.7095 12.1229 17.294 13.0864C16.8784 14.0499 16.3145 14.8879 15.6021 15.6006C14.8897 16.3132 14.052 16.8775 13.089 17.2933C12.1259 17.709 11.097 17.9168 10.0021 17.9168ZM10.0007 16.6668C11.8618 16.6668 13.4382 16.021 14.7298 14.7293C16.0215 13.4377 16.6673 11.8613 16.6673 10.0002C16.6673 8.13905 16.0215 6.56266 14.7298 5.271C13.4382 3.97933 11.8618 3.3335 10.0007 3.3335C8.13954 3.3335 6.56315 3.97933 5.27148 5.271C3.97982 6.56266 3.33398 8.13905 3.33398 10.0002C3.33398 11.8613 3.97982 13.4377 5.27148 14.7293C6.56315 16.021 8.13954 16.6668 10.0007 16.6668Z" fill="#010202"/></svg>',
    bell:    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>'
  };

  /* ── Helpers ─────────────────────────────────────────────────── */
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {}, bubbles: true }));
  }

  function t(key, fallback) {
    var val = (window.__notifyMeI18n && window.__notifyMeI18n[key]) || fallback;
    if (!val || val.indexOf('&') === -1) return val;
    var el = document.createElement('textarea');
    el.innerHTML = val;
    return el.value;
  }

  function isOpticalProductType(value) {
    return String(value || '').toUpperCase() === 'OPTICAL';
  }

  /* ══════════════════════════════════════════════════════════════
     NotifyMeTrigger — PDP button (shown when variant is unavailable)
  ══════════════════════════════════════════════════════════════ */
  class NotifyMeTrigger extends HTMLElement {
    connectedCallback()    { this.addEventListener('click', this._onClick); }
    disconnectedCallback() { this.removeEventListener('click', this._onClick); }

    _onClick = () => {
      var variantInput = document.querySelector('product-form-component input[name="id"]');
      var variantId    = (variantInput && variantInput.value) || this.dataset.variantId || '';

      emit('notify-me:open', {
        productId:    this.dataset.productId           || '',
        variantId:    variantId,
        title:        this.dataset.productTitle        || '',
        image:        this.dataset.productImage        || '',
        price:        this.dataset.productPrice        || '',
        comparePrice: this.dataset.productComparePrice || '',
        variantTitle: this.dataset.variantTitle        || '',
        sku:          this.dataset.productSku          || '',
        productUrl:   this.dataset.productUrl          || '',
        productType:  this.dataset.productType         || ''
      });
    };
  }

  /* ══════════════════════════════════════════════════════════════
     NotifyMeDrawer — drawer / bottom-sheet
  ══════════════════════════════════════════════════════════════ */
  class NotifyMeDrawer extends HTMLElement {
    constructor() {
      super();
      this._dialog      = null;
      this._content     = null;
      this._prevScrollY = 0;
      this._product     = null;
    }

    connectedCallback() {
      this._dialog   = this.querySelector('dialog');
      this._content  = this.querySelector('[data-nm-content]');

      document.addEventListener('notify-me:open', this._onOpen);
      if (this._dialog)   this._dialog.addEventListener('keydown', this._onKeyDown);
      if (this._dialog)   this._dialog.addEventListener('click', this._onDialogClick);
    }

    disconnectedCallback() {
      document.removeEventListener('notify-me:open', this._onOpen);
      if (this._dialog) this._dialog.removeEventListener('keydown', this._onKeyDown);
      if (this._dialog) this._dialog.removeEventListener('click', this._onDialogClick);
    }

    get _cfg() {
      var ds = this.dataset;
      return {
        webhookUrl:  (ds.webhookUrl  || '/apps/etniaAppSync/bis-subscribe').trim(),
        preorderUrl: (ds.preorderUrl || '/apps/etniaAppSync/preorder-subscribe').trim(),
        privacyUrl:  (ds.privacyUrl  || '/pages/privacy-policy').trim(),
        discoverUrl: (ds.discoverUrl || '').trim(),
        locale:      ds.locale || 'en-us'
      };
    }

    _onOpen = (e) => {
      this._product = e.detail || null;
      this.open();
    };

    _onKeyDown = (e) => {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); }
    };

    _onDialogClick = (e) => {
      if (e.target === this._dialog) this.close();
    };

    open() {
      if (!this._dialog || this._dialog.open) return;
      this._prevScrollY            = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top      = '-' + this._prevScrollY + 'px';
      document.body.style.width    = '100%';
      this._renderForm();
      this._dialog.showModal();
    }

    close() {
      if (!this._dialog || !this._dialog.open) return;
      this._dialog.classList.add('nm-dialog--closing');
      var self = this;
      setTimeout(function () {
        self._dialog.classList.remove('nm-dialog--closing');
        self._dialog.close();
        document.body.style.position = '';
        document.body.style.top      = '';
        document.body.style.width    = '';
        window.scrollTo({ top: self._prevScrollY, behavior: 'instant' });
      }, 240);
    }

    _productCard() {
      var p = this._product || {};
      if (!p.title) return '';
      var hasCompare = p.comparePrice && p.comparePrice !== p.price;
      return (
        '<div class="nm-product">' +
        '<div class="nm-product__img-container">' +
          (p.image ? '<img class="nm-product__img" src="' + esc(p.image) + '" alt="" width="56" height="56" loading="lazy">' : '') +
          '</div>' +
          '<div class="nm-product__info">' +
            '<p class="nm-product__title">' + esc(p.title) + '</p>' +
            '<p class="nm-product__price">' + esc(p.price) +
              (hasCompare ? ' <s class="nm-product__compare">' + esc(p.comparePrice) + '</s>' : '') +
            '</p>' +
            (p.variantTitle && p.variantTitle !== 'Default Title'
              ? '<p class="nm-product__variant">' + esc(p.variantTitle) + '</p>' : '')  +
          '</div>' +
        '</div>'
      );
    }

    _bindClose() {
      var self     = this;
      var closeBtn = this._content && this._content.querySelector('[data-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });
    }

    _renderForm() {
      if (!this._content) return;
      var cfg = this._cfg;
      var isPreorder = this._product && this._product.isPreorder;
      var submitText = isPreorder ? t('preorderBtn', 'Pre order') : t('notifyBtn', 'Notify me');
      var headerTitle = isPreorder ? t('preorderTitle', 'Pre order') : t('title', 'Notify me');
      var subtitle = isPreorder ? t('preorderSubtitle', 'Get notified when this item is here!') : t('subtitle', 'Get notified when this item is back in stock.');
      this._content.innerHTML =
        '<div class="nm-header">' +
          '<div>' +
            '<p class="nm-header__title">' + headerTitle + '</p>' +
            '<p class="nm-header__subtitle-text">' + subtitle + '</p>' +
          '</div>' +
          '<button type="button" class="nm-header__close" data-close aria-label="' + esc(t('close', 'Close')) + '">' + ICON.close + '</button>' +
        '</div>' +
        '<div class="nm-body">' +
          this._productCard() +
          '<form class="nm-form" data-form novalidate>' +
            '<div class="nm-form__field nm-form__field--float">' +
              '<input class="nm-form__input" type="email" name="email" id="nm-email-input" placeholder=" " autocomplete="email" required>' +
              '<label class="nm-form__label" for="nm-email-input">' + t('emailPlaceholder', 'Email') + '</label>' +
            '</div>' +
            '<div class="nm-form__check">' +
              '<label class="nm-form__check-label">' +
                '<input type="checkbox" name="privacy" required>' +
                '<span>' + t('privacyText', 'I accept the') + ' <a href="' + esc(cfg.privacyUrl) + '" target="_blank" class="nm-link">' + t('privacyLink', 'Privacy Policy') + '</a></span>' +
              '</label>' +
            '</div>' +
            '<div class="nm-form__check">' +
              '<label class="nm-form__check-label">' +
                '<input type="checkbox" name="newsletter">' +
                '<span>' + t('newsletterText', 'I agree to join the Newsletter and receive communications about launches, promotions and latest news.') + '</span>' +
              '</label>' +
            '</div>' +
            '<p class="nm-form__error" data-error hidden></p>' +
          '</form>' +
        '</div>' +
        '<div class="nm-footer">' +
          '<button type="button" class="nm-btn nm-btn--full" data-submit>' + submitText + '</button>' +
        '</div>';

      this._bindClose();

      var self      = this;
      var submitBtn = this._content.querySelector('[data-submit]');
      if (submitBtn) submitBtn.addEventListener('click', function () { self._handleSubmit(); });
    }

    async _handleSubmit() {
      var form      = this._content.querySelector('[data-form]');
      var submitBtn = this._content.querySelector('[data-submit]');
      var errorEl   = this._content.querySelector('[data-error]');
      if (!form) return;

      var fd         = new FormData(form);
      var email      = (fd.get('email') || '').trim();
      var privacy    = !!form.querySelector('[name="privacy"]').checked;
      var newsletter = !!form.querySelector('[name="newsletter"]').checked;

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errorEl.textContent = t('errEmail', 'A valid email is required.');
        errorEl.removeAttribute('hidden');
        return;
      }
      if (!privacy) {
        errorEl.textContent = t('errPrivacy', 'Please accept the Privacy Policy.');
        errorEl.removeAttribute('hidden');
        return;
      }
      errorEl.setAttribute('hidden', '');

      var p   = this._product || {};
      var cfg = this._cfg;
      var isPreorder = p.isPreorder === true;

      var payload = {
        email:             email,
        sku:               p.sku             || '',
        privacyPolicy:     privacy,
        newsletterConsent: newsletter,
        locale:            cfg.locale        || ''
      };

      var webhookUrl = isPreorder
        ? cfg.preorderUrl
        : cfg.webhookUrl;
      var submitText = isPreorder ? t('preorderBtn', 'Preorder') : t('notifyBtn', 'Notify me');

      submitBtn.setAttribute('disabled', '');
      submitBtn.textContent = t('submitting', 'Sending…');

      if (!webhookUrl) {
        // No webhook configured — show success without sending
        this._renderSuccess();
        return;
      }
      try {
        var res = await fetch(webhookUrl, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify(payload)
        });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        this._renderSuccess();
      } catch (_) {
        submitBtn.removeAttribute('disabled');
        submitBtn.textContent = submitText;
        errorEl.textContent   = t('errGeneric', 'Something went wrong. Please try again.');
        errorEl.removeAttribute('hidden');
      }
    }

    _renderSuccess() {
      if (!this._content) return;
      var cfg        = this._cfg;
      var p          = this._product || {};
      var isOptical  = isOpticalProductType(p.productType);
      var discoverUrl  = isOptical ? '/collections/optical' : '/collections/sun';
      var discoverText = isOptical ? t('discoverEyewear', 'Discover eyewear') : t('discoverBtn', 'Discover sunglasses');
      if (cfg.discoverUrl) discoverUrl = cfg.discoverUrl;

      this._content.innerHTML =
        '<div class="nm-success-bar">' +
          '<span class="nm-success-bar__icon">' + ICON.check + '</span>' +
          '<p class="nm-success-bar__text">' +
            '<strong>' + t('successTitle', 'You\'re all set.') + '</strong> ' +
            t('successSub', 'We\'ll email you when it\'s back') +
          '</p>' +
          '<button type="button" class="nm-header__close" data-close aria-label="' + esc(t('close', 'Close')) + '">' + ICON.close + '</button>' +
        '</div>' +
        '<div class="nm-body">' +
          this._productCard() +
          '<a href="' + esc(discoverUrl) + '" class="nm-btn nm-btn--full nm-btn--dark">' + discoverText + '</a>' +
        '</div>';

      this._bindClose();
    }
  }

  /* ── Register ───────────────────────────────────────────────── */
  if (!customElements.get('notify-me-trigger')) customElements.define('notify-me-trigger', NotifyMeTrigger);
  if (!customElements.get('notify-me-drawer'))  customElements.define('notify-me-drawer',  NotifyMeDrawer);

  /* ── Sold-out button hook ────────────────────────────────────── */
  var _productData  = {};
  var _lastVariant  = {};
  var _hookedButtons = [];
  var _variantDisplayLabels = {};
  var _variantProdStatuses = {};

  var ACTIVE_STATUSES = ['ACTIVE', 'ACTIU', 'ACTIVO'];

  function _parseVariantProdStatuses(formEl) {
    var raw = (formEl && formEl.dataset.variantProdStatuses) || '';
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (_) { return {}; }
  }

  function _isVariantStatusActive(variantId) {
    var id = String(variantId || '');
    var status = String(_variantProdStatuses[id] || '').toUpperCase();
    if (!status) return true;
    return ACTIVE_STATUSES.indexOf(status) !== -1;
  }

  function _parseVariantDisplayLabels(formEl) {
    var raw = (formEl && formEl.dataset.variantDisplayLabels) || '';
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (_) {
      return {};
    }
  }

  function _variantDisplayLabel(variantId, variant, formEl) {
    var labels = _variantDisplayLabels;
    if (!labels || !Object.keys(labels).length) {
      labels = _parseVariantDisplayLabels(formEl);
      _variantDisplayLabels = labels;
    }

    var id = String(variantId || '');
    if (id && labels[id]) return labels[id];

    if (variant && Array.isArray(variant.options)) {
      return variant.options.filter(function (v) { return v && v !== 'Default Title'; }).join(' · ');
    }

    return '';
  }

  function _findVariant(id) {
    var variants = _productData.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  function _moneyFormat(cents) {
    if (!cents) return '';
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function _nmSoldOutClick(formEl) {
    return function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var variantId = (formEl.querySelector('input[name="id"]') || {}).value || '';
      var variant   = _findVariant(variantId) || _lastVariant;
      if (!variant) return;
      var isPreorder = _isPreorderVariant(variant, formEl);

      var image = '';
      if (variant.featured_image && variant.featured_image.src) {
        image = variant.featured_image.src;
      } else if (_productData.featured_image) {
        image = _productData.featured_image;
      }

      emit('notify-me:open', {
        productId:    formEl.dataset.productId   || '',
        variantId:    variantId,
        sku:          variant.sku                || '',
        variantTitle: _variantDisplayLabel(variantId, variant, formEl),
        title:        _productData.title         || '',
        image:        image,
        price:        _moneyFormat(variant.price),
        comparePrice: variant.compare_at_price ? _moneyFormat(variant.compare_at_price) : '',
        productUrl:   formEl.dataset.productUrl  || window.location.pathname,
        productType:  (formEl.dataset.productType || _productData.product_type || '').toUpperCase(),
        isPreorder:   isPreorder
      });
    };
  }

  var _lastVariantUpdateHtml = null;

  function _getServerAddToCartButton(html) {
    var doc = html || _lastVariantUpdateHtml;
    if (!doc) return null;
    return doc.querySelector('product-form-component [ref="addToCartButton"]');
  }

  function _getServerStickyAddToCartButton(html) {
    var doc = html || _lastVariantUpdateHtml;
    if (!doc) return null;
    return doc.querySelector('sticky-add-to-cart [ref="addToCartButton"]');
  }

  function _getButtonLabelElement(btn) {
    if (!btn) return null;
    return btn.querySelector('.add-to-cart-text__content span span span') ||
           btn.querySelector('.add-to-cart-text__content span span') ||
           btn.querySelector('.add-to-cart-text__content span') ||
           btn.querySelector('.add-to-cart-text__content');
  }

  function _getButtonLabel(btn) {
    var labelEl = _getButtonLabelElement(btn);
    return labelEl ? labelEl.textContent.trim() : (btn.textContent || '').trim();
  }

  function _syncButtonFromServer(liveBtn, serverBtn) {
    if (!liveBtn || !serverBtn) return;

    var labelEl = _getButtonLabelElement(liveBtn);
    var label = _getButtonLabel(serverBtn);
    if (labelEl) labelEl.textContent = label;

    liveBtn.setAttribute('type', serverBtn.getAttribute('type') || 'submit');
    liveBtn.removeAttribute('data-puppet');

    if (serverBtn.hasAttribute('disabled')) {
      liveBtn.setAttribute('disabled', '');
    } else {
      liveBtn.removeAttribute('disabled');
    }

    liveBtn.classList.toggle('nm-sold-out-btn', serverBtn.classList.contains('nm-sold-out-btn'));
  }

  function _setNotifyMeButtonText(btn, label) {
    var labelEl = _getButtonLabelElement(btn);
    var text = label || t('notifyBtn', 'Notify me');

    if (!btn.dataset.nmOriginalText) btn.dataset.nmOriginalText = _getButtonLabel(btn) || btn.textContent || '';
    if (labelEl) {
      labelEl.textContent = text;
    } else {
      btn.textContent = text;
    }
  }

  function _getCurrentVariant(formEl) {
    var variantId = (formEl.querySelector('input[name="id"]') || {}).value || '';
    var variant = _findVariant(variantId);

    if (variant) return variant;
    if (_lastVariant && String(_lastVariant.id) === String(variantId)) return _lastVariant;

    return null;
  }

  function _getPreorderVariantIds(formEl) {
    var stickyRoot = document.querySelector('sticky-add-to-cart');
    var rawIds = [
      formEl.dataset.preorderVariantIds || '',
      stickyRoot ? stickyRoot.dataset.preorderVariantIds || '' : ''
    ].join(',');

    return rawIds.split(',').map(function (id) {
      return id.trim();
    }).filter(Boolean);
  }

  function _isPreorderVariant(variant, formEl) {
    var variantId;
    if (variant && variant.id) {
      variantId = String(variant.id);
    } else {
      variantId = (formEl.querySelector('input[name="id"]') || {}).value || '';
      variant = _findVariant(variantId);
    }
    if (!variantId) return false;

    var preorderIds = _getPreorderVariantIds(formEl);
    if (preorderIds.indexOf(variantId) === -1) return false;

    if (variant && variant.inventory_management === 'shopify') {
      return (variant.inventory_quantity || 0) <= 0;
    }

    return false;
  }

  function _restoreSoldOutButton(btn) {
    if (btn._nmHandler) {
      btn.removeEventListener('click', btn._nmHandler);
      btn.removeEventListener('click', btn._nmHandler, true);
    }
    btn._nmHandler = null;
    btn.removeAttribute('data-puppet');
    delete btn.dataset.nmOriginalType;
    delete btn.dataset.nmOriginalText;
  }

  function _hookSoldOutButton(btn, handler, label) {
    if (!btn || btn._nmHandler) return;
    delete btn.dataset.nmOriginalText;
    if (!btn.dataset.nmOriginalType) btn.dataset.nmOriginalType = btn.getAttribute('type') || 'button';
    btn.removeAttribute('disabled');
    btn.setAttribute('type', 'button');
    btn.dataset.puppet = 'true';
    btn.classList.add('nm-sold-out-btn');
    var stickyRoot = btn.closest('sticky-add-to-cart');
    if (stickyRoot) {
      stickyRoot.classList.add('nm-sticky-notify');
    }
    _setNotifyMeButtonText(btn, label);
    btn._nmHandler = handler;
    btn.addEventListener('click', btn._nmHandler, true);
    if (_hookedButtons.indexOf(btn) === -1) _hookedButtons.push(btn);
  }

  function hookSoldOutBtn() {
    var formEl = document.querySelector('product-form-component');
    if (!formEl) return;

    var variantId = (formEl.querySelector('input[name="id"]') || {}).value || '';
    var currentVariant = _getCurrentVariant(formEl);
    var statusActive = _isVariantStatusActive(variantId);
    var serverBtn = _getServerAddToCartButton();
    var serverStickyBtn = _getServerStickyAddToCartButton();
    var formBtn = formEl.querySelector('button[ref="addToCartButton"]');
    var stickyBtn = document.querySelector('sticky-add-to-cart button[ref="addToCartButton"]');
    var stickyRoot = document.querySelector('sticky-add-to-cart');

    // On initial page load there is no fetched variant-update HTML yet, so fall back
    // to the button already rendered by Liquid — it's the authoritative source (it
    // accounts for quantity rules / inventory policy that the client-side variant
    // JSON below does not) and hasn't been touched by this script yet.
    if (!serverBtn && !_lastVariantUpdateHtml) serverBtn = formBtn;
    var useServerState = !!serverBtn;

    var buttonsToRestore = Array.from(document.querySelectorAll('.nm-sold-out-btn'));
    _hookedButtons.forEach(function (btn) {
      if (buttonsToRestore.indexOf(btn) === -1) buttonsToRestore.push(btn);
    });

    buttonsToRestore.forEach(function (btn) {
      _restoreSoldOutButton(btn);
    });
    _hookedButtons = [];

    var shouldShowPreorder = false;
    var shouldShowNotifyMe = false;

    if (useServerState && !serverBtn.classList.contains('nm-sold-out-btn')) {
      _syncButtonFromServer(formBtn, serverBtn);
      if (serverStickyBtn) {
        _syncButtonFromServer(stickyBtn, serverStickyBtn);
      } else if (stickyBtn) {
        _syncButtonFromServer(stickyBtn, serverBtn);
      }
      if (stickyRoot) {
        stickyRoot.classList.remove('nm-sticky-notify');
        stickyRoot.dataset.variantAvailable = serverBtn.hasAttribute('disabled') ? 'false' : 'true';
      }
      return;
    }

    if (useServerState) {
      shouldShowPreorder = _getPreorderVariantIds(formEl).indexOf(String(variantId)) !== -1;
      shouldShowNotifyMe = !shouldShowPreorder;
    } else {
      shouldShowPreorder = _isPreorderVariant(currentVariant, formEl);
      shouldShowNotifyMe = currentVariant &&
        (currentVariant.available === false || !statusActive) &&
        !shouldShowPreorder;
    }

    if (!shouldShowNotifyMe && !shouldShowPreorder) return;

    var handler = _nmSoldOutClick(formEl);
    var label = shouldShowPreorder ? t('preorderBtn', 'Preorder') : t('notifyBtn', 'Notify me');
    [formBtn, stickyBtn].forEach(function (btn) {
      _hookSoldOutButton(btn, handler, label);
    });
  }

  function _loadProductData() {
    var formEl = document.querySelector('product-form-component');
    if (!formEl || !formEl.dataset.productUrl) return;
    fetch(formEl.dataset.productUrl + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        _productData = data;
        var variantId = (formEl.querySelector('input[name="id"]') || {}).value;
        var variant   = _findVariant(variantId);
        if (variant) _lastVariant = variant;
        hookSoldOutBtn();
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', _loadProductData);

  document.addEventListener('variant:update', function (e) {
    if (e.detail && e.detail.resource) _lastVariant = e.detail.resource;
    if (e.detail && e.detail.data && e.detail.data.html) {
      _lastVariantUpdateHtml = e.detail.data.html;
    }
    var formEl = document.querySelector('product-form-component');
    if (formEl) {
      _variantDisplayLabels = _parseVariantDisplayLabels(formEl);
      _variantProdStatuses  = _parseVariantProdStatuses(formEl);
    }
    requestAnimationFrame(hookSoldOutBtn);
  });

})();
